import { ChangeEvent, FC, useState } from 'react'
import { StyleFormWrapper, StyleLabel } from '../style'
import { StyleIconWrapper, StyleInput, StyleInputWrapper } from './style'
import { Field } from 'formik'
import ErrorMessage from '../ErrorMessage'
import icons from '@assets/icons'
import Svg from '../../svg'
interface InputProps {
  type?: 'text' | 'password' | 'email' | 'url' | 'date'
  onChange?: (value: string) => void
  placeholder?: string
  label?: string
  required?: boolean
  name: string
  styleInput?: string
  styleLabel?: string
  styleWrapper?: string
  icon?: keyof typeof icons
  side?: 'left' | 'right'
  disabled?: boolean
}
const Input: FC<InputProps> = ({
  type = 'text',
  label,
  name,
  onChange,
  styleWrapper = '',
  styleLabel = '',
  icon,
  side = 'left',
  ...restProps
}) => {
  const [focus, setFocus] = useState<boolean>(false)
  const handleChange = ({ form, value }: any) => {
    onChange && onChange(value)
    form.setFieldValue(name, value)
  }

  return (
    <Field name={name}>
      {({ field, meta, form }) => {
        const hasError = meta.touched && meta.error
        return (
          <StyleFormWrapper styleWrapper={styleWrapper}>
            {!!label && (
              <StyleLabel hasError={hasError} styleLabel={styleLabel}>
                {label}
              </StyleLabel>
            )}
            <StyleInputWrapper>
              {!!icon && (
                <StyleIconWrapper side={side}>
                  <Svg src={icon} size={16} color="placeholder" />
                </StyleIconWrapper>
              )}
              <StyleInput
                type={type}
                value={field?.value || ''}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                  handleChange({
                    form,
                    value: event.target.value,
                  })
                }}
                isFocus={focus}
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
                hasError={hasError}
                side={side}
                hasIcon={!!icon}
                {...restProps}
              />
            </StyleInputWrapper>
            {!!hasError && <ErrorMessage message={meta.error} />}
          </StyleFormWrapper>
        )
      }}
    </Field>
  )
}

export default Input
